export default {
  // Nav
  nav_spreadsheet: "Spreadsheet",
  nav_categories: "Categories",
  nav_guides: "Guides",
  nav_reviews: "Reviews",
  nav_shipping: "Shipping",
  nav_safety: "Safety",
  nav_language: "Language",

  // Hero
  hero_eyebrow: "THE ALLCHINABUY SPREADSHEET RESOURCE HUB",
  hero_title: "AllChinaBuy Spreadsheet — Find Products, Links & Buying Guides",
  hero_subtitle: "Discover organized AllChinaBuy spreadsheet resources, product links, buying guides, QC tips, shipping information and helpful tools — all in one place.",
  hero_cta_primary: "Explore AllChinaBuy Spreadsheet",
  hero_cta_secondary: "Browse Popular Categories",
  hero_trust: "Independent resource • Updated regularly • Safety-focused",

  // Categories dropdown
  categories_title: "Shop by Category",
  categories_description: "Browse our curated categories and find exactly what you need",
  categories_button: "All Categories",

  // Main CTAs
  cta_spreadsheet: "AllChinaBuy Spreadsheet",
  cta_buy_now: "Buy It Now",
  cta_explore: "Explore Products",

  // Value Proposition
  value_title: "Everything You Need to Navigate AllChinaBuy",
  value_spreadsheet: "Spreadsheet Resources",
  value_spreadsheet_desc: "Find organized spreadsheet resources and product references.",
  value_discovery: "Product Discovery",
  value_discovery_desc: "Explore popular categories and discover useful product information.",
  value_qc: "QC Guides",
  value_qc_desc: "Learn how to evaluate quality-control photos and product details.",
  value_shipping: "Shipping Guides",
  value_shipping_desc: "Understand shipping options, costs, tracking and important considerations.",
  value_safety: "Safety Center",
  value_safety_desc: "Learn how to reduce common buying, payment and seller-related risks.",
  value_comparison: "Comparison Guides",
  value_comparison_desc: "Compare buying platforms, features and user considerations.",

  // Popular Categories
  popular_title: "Popular AllChinaBuy Spreadsheet Categories",
  popular_desc: "Explore our most visited product categories and discover trending items",

  // How It Works
  how_title: "How to Use an AllChinaBuy Spreadsheet",
  how_step1_title: "Choose a Category",
  how_step1_desc: "Browse products by category and intent.",
  how_step2_title: "Review Product Information",
  how_step2_desc: "Check available information, references and QC considerations.",
  how_step3_title: "Compare Options",
  how_step3_desc: "Use comparison tables and guides before making decisions.",
  how_step4_title: "Continue to the Main Website",
  how_step4_desc: "Use the relevant CTA when you are ready to continue.",

  // Trust
  trust_title: "Built for Smarter Buying Research",
  trust_desc: "AllChinaBuySpreadsheet.fit is an independent informational resource designed to organize useful spreadsheet resources and buying information. We focus on clarity, practical guidance, safety and regularly updated content.",
  trust_point1: "Independent resource",
  trust_point2: "Transparent information",
  trust_point3: "Safety-focused guides",
  trust_point4: "Regular content updates",
  trust_point5: "Clear editorial standards",

  // Articles
  articles_title: "Latest AllChinaBuy Spreadsheet Guides",
  articles_desc: "Read our in-depth articles to become a smarter buyer",
  articles_read_more: "Read More",
  articles_category: "Category",
  articles_read_time: "Read time",

  // CTA Section
  final_cta_title: "Ready to Explore the AllChinaBuy Spreadsheet?",
  final_cta_desc: "Browse the latest resources, discover useful categories and learn how to navigate the buying process with more confidence.",
  final_cta_primary: "Explore AllChinaBuy Spreadsheet",
  final_cta_secondary: "Read the Beginner's Guide",

  // Footer
  footer_tagline: "Your independent resource for AllChinaBuy spreadsheet resources and buying guides.",
  footer_resources: "Resources",
  footer_spreadsheet: "Spreadsheet Hub",
  footer_categories: "Categories",
  footer_guides: "Guides",
  footer_reviews: "Reviews",
  footer_legal: "Legal",
  footer_about: "About Us",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Service",
  footer_disclaimer: "Disclaimer",
  footer_contact: "Contact",
  footer_email: "Email Us",
  footer_social: "Follow Us",
  footer_copyright: "AllChinaBuySpreadsheet.fit. All rights reserved.",
  footer_independent: "This is an independent resource hub. We are not affiliated with AllChinaBuy.",

  // Article page
  article_back: "Back to Home",
  article_updated: "Last Updated",
  article_share: "Share this article",
  article_related: "Related Articles",
  article_read_more: "Read More",
  article_author: "Editorial Team",
  article_table_of_contents: "Table of Contents",
  article_jump_to: "Jump to section",

  // Safety section
  safety_title: "Shop Smarter With Our Safety Guides",
  safety_desc: "Before using any product link or placing an order, learn how to evaluate sellers, product information, QC photos, payment methods and shipping risks.",
  safety_cta: "Visit the Safety Center",
  safety_notice: "Always verify current product, seller, payment and shipping information before ordering. Details may change over time.",

  // Comparison
  comparison_title: "AllChinaBuy & Popular Buying Platforms",
  comparison_note: "Verify current information before ordering.",
  comparison_platform: "Platform",
  comparison_spreadsheet: "Spreadsheet Resources",
  comparison_qc: "QC",
  comparison_shipping_info: "Shipping Information",
  comparison_beginner: "Beginner Friendly",

  // Misc
  read_guide: "Read Guide",
  learn_more: "Learn More",
  search_placeholder: "Search AllChinaBuy spreadsheets, products, categories or guides...",
  search_title: "Find What You're Looking For",
  search_suggested: "Suggested searches",
  featured_spreadsheet: "AllChinaBuy Spreadsheet",
  featured_spreadsheet_desc: "Start with the most important resource on this website. Explore organized spreadsheet information, categories, product references and practical buying guidance.",
  explore_spreadsheet: "Explore the Spreadsheet",
  home_breadcrumb: "Home",
  article_breadcrumb: "Articles",
  scroll_to_top: "Back to top",
  main_website: "Main Website",
  visit_main: "Visit Main Website",

  // Products
  products_title: "All Products from Kakobuy Spreadsheet",
  products_subtitle: "Browse our complete collection of curated products with direct links to buy",
  products_view_all: "View all {category}",
  products_buy_now: "Buy Now",
  products_from: "From",
};